import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { canViewAssetLogs } from '../service/asset-logs.service';

/**
 * Guard that restricts access to Asset Activity Logs to ADMIN and HR-HEAD departments only.
 * Unauthorized users are redirected to the inventory dashboard.
 */
export const assetLogsGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  if (!canViewAssetLogs()) {
    router.navigate(['/inventory/dashboard']);
    return false;
  }

  return true;
};
